import React from 'react';

import { Block } from '../common/Block.jsx';
import { EditorContainer } from '../layout/Builder.jsx';
import * as Cell from '../common/Cell.jsx';
import { Animation } from '../common/Container.jsx';
import { withHoverEffects } from '../common/Image.jsx';
import Name from '../common/Name.jsx';
import Token from '../common/Token.jsx';
import Url from '../common/Url.jsx';
import Utilities from '../common/Utilities.jsx';

function ArtistCellContainer(props) {
    let link;
    if (props.data) {
        link = Url.getLink('', `artist/${props.data.artistId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder);
    }
    let className = 'cell--whitelabel--artist';
    switch (props.type) {
        case 'slideshow':
            className += ' slider__slide';
            break;
    }
    let content = <Cell.Container {...props} className={className} link={link} useCellSpacer={false} />;
    switch (props.animation) {
        case '1':
            content = <Animation active={props.active} builder={props.builder}>{content}</Animation>
            break;
    }
    return content;
}

function ArtistCellPreviewContainer(props) {
    const contentConfig = props.contentConfig || {};
    let blocks = [];
    if (contentConfig.desktop && contentConfig.desktop.blocks) {
        blocks = contentConfig.desktop && contentConfig.desktop.blocks;
    }
    let containerStyle = {};
    Utilities.copyObject(props.style, containerStyle);
    let handleBuilderBlockProps;
    if (props.builder) {
        handleBuilderBlockProps = (d) => {
            if (!d.type) {
                return;
            }
            switch (d.type.value) {
                case Name.Block.Artist.Cell.Image:
                    if (props.inLayout && d.config && d.config.layout && d.config.layout.maxHeight && d.config.layout.maxHeight.value && d.config.layout.maxHeight.value.length > 0) {
                        break;
                    }
                    return { style: { width: '100%' } };
            }
        }
        if (!props.editor) {
            containerStyle.pointerEvents = 'none';
        }
    }
    let className = 'cell--whitelabel cell--whitelabel--artist artist__preview';
    if (props.className) {
        className += ` ${props.className}`;
    }
    if (!props.builder && !props.data) {
        return <div className={className} style={containerStyle} />
    }
    let link;
    if (props.data) {
        link = Url.getLink('', `artist/${props.data.artistId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder);
    }
    return (
        <EditorContainer
            {...props}
            blocks={blocks}
            builderBlockPropsHandler={handleBuilderBlockProps}
            className={className}
            containerProps={contentConfig.desktop && contentConfig.desktop.page}
            link={link}
            style={containerStyle}
            onContainerProps={props.onPageProps} />
    );
}

// region ARTIST IMAGE

function _ArtistImageComponent(props) {
    const data = props.data || {};

    const [blip, setBlip] = React.useState(undefined);
    React.useEffect(() => {
        if (blip == undefined) {
            // First time through, no blip
            setBlip(false);
            return;
        }
        if (blip) {
            return;
        }
        setBlip(true);
        setTimeout(() => setBlip(false), 0);
    }, [data.artistId])

    let image = data.cover;
    let imageStyle;
    if (props.blockConfig && props.blockConfig.block) {
        imageStyle = {};
        Block.mapStyleConfigProps(imageStyle, props.blockConfig.block, (propName, propValue) => {
            switch (propName) {
                case 'isCropped':
                    return true;
                case 'source':
                    image = data[propValue];
                    return true;
            }
        })
    }
    if (blip) {
        return <div className="artist__card__img" style={imageStyle} />
    }
    const handleBlockProps = (_, propName) => propName == 'alignItems';
    return (
        <Cell.Image
            {...props}
            blockPropsHandler={handleBlockProps}
            className="artist__card__img"
            image={image}
            imageAlignment="unset"
            imageData={{ alt: data.name, title: data.name }}
            imageId={image && image.id}
            imageStyle={imageStyle} />
    );
}
const ArtistImageComponent = withHoverEffects(_ArtistImageComponent, 'layout');
const ArtistImage = { Component: ArtistImageComponent };

// region ARTIST META

function ArtistMetaComponent(props) {
    const handleTokenReplacement = (keyword, options) => Token.parsing.artist(
        { artist: props.data, contentClassName: { [Token.ArtistName]: 'artist__card__name' } },
        keyword,
        options
    );
    return <Cell.Meta {...props} parseConditions={[props.data.name]} onTokenReplacement={handleTokenReplacement} />
}
const ArtistMetaTokens = () => {
    return [
        { display: 'Artist Name', token: Token.ArtistName },
        Token.getWrappedTokenConfig('Artist Lifespan', Token.ArtistLifespan)
    ];
}
const ArtistMeta = { Component: ArtistMetaComponent, Tokens: ArtistMetaTokens };

export {
    ArtistCellContainer,
    ArtistCellPreviewContainer,
    ArtistImage,
    ArtistMeta
}